function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRealEstateIconDk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 250,
    style: {
      fill: "#e06b30"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.9,
    y: 385.67,
    width: 362.2,
    height: 0.14,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 13
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250 114.09 151 213.09 170.7 232.79 250 153.49 329.3 232.79 349 213.09 250 114.09",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 13
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.04 206.13 349 213.09 329.3 232.79 312.69 216.18 312.69 385.74 410.2 385.74 410.2 206.13 342.04 206.13",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 13
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151 213.09 157.79 206.3 89.8 206.3 89.8 385.91 187.31 385.91 187.31 216.18 170.7 232.79 151 213.09",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 13
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.07 206.13 385.08 139.21 275.12 139.21 342.04 206.13 438.07 206.13",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 13
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.92 139.39 61.93 206.3 157.79 206.3 224.7 139.39 114.92 139.39",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 13
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.31 216.18 187.31 385.74 312.69 385.74 312.69 216.18 250 153.49 187.31 216.18",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 13
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.14,
    y: 254.88,
    width: 34.83,
    height: 41.79,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 13
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.03,
    y: 254.88,
    width: 34.83,
    height: 41.79,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 13
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.1,
    y: 223.15,
    width: 41.79,
    height: 41.79,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 13
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.62,
    y: 316.08,
    width: 48.76,
    height: 69.65,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 13
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealEstateIconDk);
export default __webpack_public_path__ + "static/media/real-estate-icon-dk.8e0d272ef6660ea999bd28c70cc081a7.svg";
export { ForwardRef as ReactComponent };